export default __webpack_public_path__ + "static/media/radiobutton_active_white.e9b93567.svg";